import { useEffect, useState, useCallback, forwardRef, useMemo } from 'react';
import LongText from './index';
import { getMaskedValue } from '../helpers';

const MaskedLongText = forwardRef(
  ({ value, displayMaskedValue, onChange, onFocus, onBlur, ...other }, ref) => {
    const [displayValue, setDisplayValue] = useState(
      displayMaskedValue ? getMaskedValue(value) : value
    );
    const [actualValue, setActualValue] = useState(value);
    const [displayToolTip, setDisplayToolTip] = useState(true);
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
      if (!isFocused) {
        setActualValue(value);
        setDisplayValue(displayMaskedValue ? getMaskedValue(value) : value);
      }
    }, [value, isFocused, displayMaskedValue]);

    const handleChange = useCallback(
      (eventValue) => {
        setActualValue(eventValue);
        setDisplayValue(eventValue);
        if (onChange) {
          onChange(eventValue);
        }
      },
      [onChange]
    );

    const handleBlur = useCallback(
      (e) => {
        setIsFocused(false);
        const maskedValue = displayMaskedValue
          ? getMaskedValue(actualValue)
          : actualValue;
        setDisplayValue(maskedValue);
        setDisplayToolTip(true);
        onBlur?.(e);
      },
      [displayMaskedValue, actualValue, onBlur]
    );

    const handleFocus = useCallback(
      (e) => {
        setIsFocused(true);
        setDisplayValue(actualValue);
        setDisplayToolTip(false);
        onFocus?.(e);
      },
      [actualValue, onFocus]
    );

    const tooltipLabel = useMemo(
      () => (displayMaskedValue && displayToolTip ? actualValue : undefined),
      [displayMaskedValue, displayToolTip, actualValue]
    );

    return (
      <LongText
        ref={ref}
        {...other}
        value={displayValue}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={handleFocus}
        tooltipLabel={tooltipLabel}
        truncate={!displayMaskedValue}
        tooltipMaxWdith={400}
        displayMaskedValue={displayMaskedValue}
        displayUrlLink={false}
      />
    );
  }
);

export default MaskedLongText;
